/**
 * Module subject extractor.
 *
 * Extracts CASL subjects from module definitions.
 */

import type { ModuleManifest } from '@gzl10/nexus-sdk'
import { getTableAndSubject } from './definition-extractors.js'

/**
 * Gets all CASL subjects of a module (from definitions).
 */
export function getModuleSubjects(mod: ModuleManifest): string[] {
  const subjects = new Set<string>()
  for (const def of mod.definitions ?? []) {
    const { subject } = getTableAndSubject(def)
    if (subject) subjects.add(subject)
  }
  return [...subjects]
}
